import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { RouteDefinition } from './types';

const ReadingPassage = lazy(() => import('../pages/ReadingPassage'));

export const readingRoutes: RouteDefinition[] = [
  // Redirect old URL to new tab route
  { path: '/reading/topics', element: <Navigate to="/read" replace /> },
  { path: '/reading/:passageId', element: <ReadingPassage />, guard: 'onboarding' },
];
